import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { Client } from 'src/providers/client/client';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { WindowService } from 'src/shared/providers/window.service';
import { Requests } from 'src/providers/requests/requests';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Pros } from 'src/providers/pros/pros';
import { Schedule } from 'src/providers/schedule/schedule';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { Me } from 'src/providers/me/me';

import { Util } from 'src/shared/util/util';

import { ConfirmPageParamsModel, ConfirmPage } from '../confirm/confirm.component';

@Component({
  templateUrl: 'pending-pro-request.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class PendingProRequestPage implements OnInit {

  addressesResponse: any;
  propertyItems: any;
  dialogParams: any;  
  request: any;
  bookingFormAnswers: any;
  address: any;
  isRightSideContent: boolean;

  constructor(
    private client: Client,
    private rightSidePanelService: RightSidePanelService,
    private util: Util,
    public windowService: WindowService,
    public requests: Requests,
    public schedule: Schedule,
    private storage: TidyStorage,
    private navCtrl: CustomNavController,
    public me: Me,
    private pros: Pros,
    private modalCtrl: ModalController
  ) {}

  async ngOnInit() {
    try {
      this.dialogParams = await this.storage.retrieve('dialog-params');
      this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
      this.rightSidePanelService.setDialogPageTitle('Pro Request');
      this.bookingFormAnswers = await this.getParam('bookingFormAnswers');
      this.address = await this.getParam('address');
      const availabilityRequestId = await this.getParam('availabilityRequestId');
      const requests = await this.schedule.getFullCards(this.address.id);
      this.request = requests.find(card => card.id.includes(availabilityRequestId));
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message);
    }
  }

  async getParam(paramName): Promise<any> {
    const param = this.dialogParams?.[paramName] || this.navCtrl.getParam(paramName);
    return param;
  }
  

  async goToChangePro(card) {
    try {
      const privateProsList = await this.pros.getAllPrivatePros();
      const params = {
        job: card,
        addressId: this.address.id,
        privateProsList,
        booking: card.template_data.booking
      }
      const url = privateProsList?.length ? 'assign-pro' : 'why-add-private-pros';
      this.rightSidePanelService.navigateTo(url, params);
    } catch(err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message);
    }
  }

  async cancelProRequest(availabilityRequest) {
    const params: ConfirmPageParamsModel = {
      title: 'Cancel Request?',
      body: 'You can always create a new request if you\'d like.',
      backText: 'Go Back',
      confirmText: 'Cancel Request',
      confirmAction: this.confirmCancelProRequest.bind(this, availabilityRequest)
    }
    const confirmationModal = await this.modalCtrl.create({
      component: ConfirmPage,
      componentProps: params,
      animated: false,
      cssClass: 'confirm-modal'
    });
    await confirmationModal.present();
  }

  async confirmCancelProRequest(availabilityRequest) {
    try {
      await this.schedule.cancelCrafRequest(availabilityRequest.id);
      await this.modalCtrl.dismiss();
      if (this.isRightSideContent) {
        this.rightSidePanelService.closeRightSidePanel();
      } else {
        this.navCtrl.back();
      }
    } catch(err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message);
      throw err;
    }
  }
  
  goToRequestProCounter(availabilityRequest) {
    const params = {
      planFrequency: availabilityRequest.frequency,
      service: availabilityRequest.service_type_details,
      proposedTimes: availabilityRequest.request_times,
      proName: availabilityRequest.homekeeper?.name?.split(' ')?.[0],
      hkId: availabilityRequest.homekeeper?.id,
      availabilityRequestId: availabilityRequest.id,
      addressId: this.address?.id,
      addressName: this.address?.address_name || this.address?.address1
    };
    this.rightSidePanelService.navigateTo('request-pro-counter', params);
  }
  
}